import { IResponse } from "models";

export enum ActionType {
  DASHBOARD_INFO = "action/DASHBOARD_INFO",
  DASHBOARD_INFO_SUCCESS = "action/DASHBOARD_INFO_SUCCESS",
  DASHBOARD_INFO_ERROR = "action/DASHBOARD_INFO_ERROR",
  DASHBOARD_INFO_RESET = "action/DASHBOARD_INFO_RESET",
}

export interface Action<T> {
  type: ActionType;
  payload: T;
}

export interface IDashboardInfoPayload {
  user_ids?: any;
  patient_ids?: any;
}

export interface IDashboardInfoResponse extends IResponse {
  result: any;
}
